import styled from "styled-components";

export const Container = styled.div`
  width: 100wh;
  height: 100vh;
  background-color: rgb(184, 184, 184, 0.5);
  z-index: 500;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const BtnContainer = styled.div`
  width: calc(80%);
  background-color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
`;
